import React from 'react';
import '../styles/components/MomentExpression.css';

interface MomentExpressionProps {
  moments: {
    id: number;
    name: string;
    operation: string;
  }[];
  isPreview?: boolean;
  onMomentClick?: (momentId: number) => void;
}

const MomentExpression: React.FC<MomentExpressionProps> = ({ 
  moments, 
  isPreview = false, 
  onMomentClick 
}) => {
  const handleMomentClick = (momentId: number) => {
    if (onMomentClick) {
      onMomentClick(momentId);
    }
  };

  if (isPreview) {
    return (
      <div className="preview-moments-expression">
        {moments.map((moment, index) => (
          <React.Fragment key={index}>
            <span 
              className={`preview-moment ${moment.id === 0 ? 'undefined-moment' : ''}`}
              onClick={() => handleMomentClick(moment.id)}
            >
              {moment.name}
            </span>
            {index < moments.length - 1 && (
              <span className="preview-operation">
                {moment.operation}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <div className="expression-content">
      {moments.map((moment, index) => (
        <React.Fragment key={index}>
          <span 
            className={`moment-name ${moment.id === 0 ? 'undefined-moment' : ''}`}
            onClick={() => handleMomentClick(moment.id)}
          >
            {moment.name}
          </span>
          {index < moments.length - 1 && (
            <span className="operation-name">
              {moment.operation}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default MomentExpression; 